module.exports = __webpack_public_path__ + "static/img/xmjt.004c58b1.png";